var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-sheet',{staticClass:"mt-5 pa-5",attrs:{"tile":""}},[_c('v-container',[_c('v-card',{staticClass:"mx-auto",attrs:{"height":"300px","width":"150px"}},[_c('v-subheader',[_vm._v(_vm._s(_vm.$t('ITEM.NOTES')))])],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }